import { Component, ElementRef, forwardRef, Input, NgZone, OnDestroy, OnInit, Renderer2, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Observable, Subscription } from 'rxjs';
import { UtilService } from 'src/app/services/util.service';
import { curNodeData } from 'src/app/STORE/selectors/propertypane.selector';
import { selectedScreen } from 'src/app/STORE/selectors/screens.selector';
@AutoUnsubscribe()
@Component({
  selector: 'vb-mobile-layout',
  templateUrl: './mobile-layout.component.html',
  styleUrls: ['./mobile-layout.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MobileLayoutComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class MobileLayoutComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private zone = inject(NgZone);
  private store = inject(Store);
  private util = inject(UtilService);
  private translate = inject(TranslateService);

  @Input() element: any;
  @Input() currentScreen: any;
  @Input() disableField = false;
  private modelValue: any;
  private onChange: (m: any) => void;
  private onTouched: (m: any) => void;
  disabled = false;

  showLayoutBuilder = false;
  layoutdata: any = null;
  layoutOptions: any = {
    minCols: 4,
    maxCols: 4,
    maxItemCols: 4
  };
  dialogHeader: any;
  nodeChildren$: Observable<any> = this.store.select(curNodeData);
  nodeChildernSub: Subscription;
  formGroup: FormGroup;
  formControl: any = [];
  formItems: any = [];
  fieldSearch = '';
  cols = [
    {
      field: 'name',
      header: 'FIELD_NAME'
    },
    {
      field: 'added',
      header: 'ADDED'
    }
  ];
  techStack: any;
  allFields: any = [];

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.setValueToGrister(value);
    this.modelValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disabled = isDisabled;
  }

  setValueToGrister(value: any) {
    if (value) {
      if (!this.layoutdata) {
        this.layoutdata = {};
      }
      this.layoutdata.alignment = value;
    }
  }

  handleCSSChangeFromGridster1(event: any) {
    // console.log('STYLES : ', event);
    this.showLayoutBuilder = false;
    this.modelValue = event;
    this.layoutdata.alignment = event;
    this.onChange(this.modelValue);
  }

  clearFilter(par?: any) {
    this.fieldSearch = '';
  }

  handleCSSChangeFromGridster(event: any) {
    // Hide the layout builder
    this.showLayoutBuilder = false;

    // Clone the event to avoid modifying the original object
    const updatedEvent = { ...event };

    // Extract the IDs from the raw part of the event
    const eventRawIds = event.raw.map((item: any) => item.id);

    // Extract the IDs from layout.items
    const layoutItemIds = this.layoutdata.items.map((item: any) => item.id);

    // Filter out any raw IDs that are not in layout items
    const filteredRawIds = eventRawIds.filter((id) => layoutItemIds.includes(id));

    // Now filter the CSS string
    let filteredCSS = event.css;

    // Loop through each raw ID and remove the corresponding CSS if the ID is not present in layout items
    eventRawIds.forEach((id) => {
      if (!filteredRawIds.includes(id)) {
        const regex = new RegExp(`#${id}\\{[^}]*\\}`, 'g'); // Matches the specific CSS rule for that ID
        filteredCSS = filteredCSS.replace(regex, ''); // Remove the CSS rule from the CSS string
      }
    });

    // Update the event with the filtered CSS and raw data
    updatedEvent.css = filteredCSS;
    updatedEvent.raw = event.raw.filter((item: any) => layoutItemIds.includes(item.id));

    // Assign the filtered event to modelValue and layoutdata.alignment
    this.modelValue = updatedEvent;
    this.layoutdata.alignment = updatedEvent;

    // Trigger change detection
    this.onChange(this.modelValue);
  }

  openLayoutBuilder() {
    this.nodeChildernSub = this.nodeChildren$.subscribe((data: any) => {
      this.allFields = data.map((item) => ({
        ...item,
        added: this.layoutdata?.alignment?.raw?.some((field) => field.id === item.id)
      }));
      if (data) {
        this.layoutdata = {
          ...this.layoutdata,
          containerName: 'tableName',
          items: this.layoutdata?.alignment?.raw
        };
        if (this.layoutdata?.alignment?.raw) {
          const raw = this.layoutdata.alignment.raw.map((rawItem: any) => {
            const matchedField = this.allFields.find((field: any) => field.id === rawItem.id);
            return matchedField ? { ...rawItem, label: matchedField.label } : rawItem;
          });
          this.layoutdata = {
            ...this.layoutdata,
            alignment: {
              ...this.layoutdata.alignment,
              raw
            }
          };
        }
        this.buildStyleEditorForm(data);
        this.zone.run(() => {
          this.showLayoutBuilder = true;
        });
      }
    });
  }

  buildStyleEditorForm(data) {
    this.formControl = [];
    data.map((item: any) => {
      if (item.label) {
        this.formControl[item.label.trim()] = new FormControl('');
      }
    });
    this.formItems = data;
    this.formGroup = new FormGroup(this.formControl);
  }

  triggerClickOfGridsterSave() {
    $('#gridsterSaveBtn').click();
  }

  handleSelectionChange(event: any, tblData: any, field: string) {
    if (tblData.added) {
      // Add item to layoutdata.items
      if (this.layoutdata?.items?.length >= 16) {
        this.allFields = this.allFields.map((item) => (item.id === tblData.id ? { ...item, added: false } : item));
        this.util.showError(this.translate.instant('LAYOUT_LIMIT_EXCEEDED'));
        return;
      }

      this.layoutdata = {
        ...this.layoutdata,
        items: [...(this.layoutdata?.items || []), tblData]
      };
    } else {
      // Remove item from layoutdata.items
      this.layoutdata = {
        ...this.layoutdata,
        items: this.layoutdata.items.filter((item) => item.id !== tblData.id) // Filter out the item
      };
    }
  }

  findAlignColumns(node: any) {
    // Check if the current node contains the 'alignColumns' property
    if (node?.data?.properties?.alignColumns) {
      return node.data.properties.alignColumns;
    }

    // If the node has children, search recursively
    if (node.children) {
      for (const child of node.children) {
        const result = this.findAlignColumns(child);
        if (result) {
          return result;
        }
      }
    }

    // Return null if 'alignColumns' is not found
    return null;
  }

  ngOnInit(): void {
    this.dialogHeader = `${this.currentScreen?.pageName} : Align Columns`;
  }

  ngOnDestroy(): void {
    if ($(this.elementRef.nativeElement)) {
      $(this.elementRef.nativeElement).remove();
    }
  }

  closeDialog() {
    this.showLayoutBuilder = false;
  }
}
